import React, { Fragment, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import LinkIcon from "@mui/icons-material/Link";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { ComponentHeader } from "../../../../../components";
import { colors } from "../../../../css components/Style";
import { CheckCircle } from "@mui/icons-material";

const Card = styled(Box)(({ active, editState }) => ({
  flex: 1,
  padding: "20px",
  borderRadius: "12px",
  cursor: "pointer",
  border: editState
    ? active
      ? `2px solid ${colors.publicisBlue}`
      : `1px solid #cbcbcb`
    : "1px solid #cbcbcb",
  background: active ? "#1048dd17" : "transparent",
  transition: "all 0.3s ease",
  display: "flex",
  gap: "16px",
  alignItems: "flex-start",
}));

export default function FormQueryType({ formikProps, editState }) {
  const [selected, setSelected] = useState(formikProps.values.query_type);

  return (
    <Fragment>
      <Grid size={12}>
        <ComponentHeader title="Overall Campaign Logic" />{" "}
      </Grid>

      <Grid size={4}>
        <Card
          sx={{
            pointerEvents: !editState && "none",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            padding: "16px",
          }}
          editState={editState}
          active={selected === "or" ? 1 : 0}
          onClick={() => {
            setSelected("or");
            formikProps.setValues((prev) => ({
              ...prev,
              query_type: "or",
            }));
          }}
        >
          <Box sx={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
            <CompareArrowsIcon
              sx={{ color: editState ? colors.publicisBlue : "#808080" }}
            />

            <Box>
              <Typography
                sx={{
                  color: editState ? colors.publicisBlue : "#808080",
                  fontWeight: 600,
                }}
              >
                OR Logic (Match Any)
              </Typography>

              <Typography sx={{ color: "#333", fontSize: "14px" }}>
                Matches users who meet at least one selected audience filter.
              </Typography>
            </Box>
          </Box>

          {selected === "or" && (
            <CheckCircle
              sx={{
                color: colors.publicisBlue,
                borderRadius: "50%",
                fontSize: 24,
                marginTop: "4px",
              }}
            />
          )}
        </Card>
      </Grid>

      <Grid size={4}>
        <Card
          sx={{
            pointerEvents: !editState && "none",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            padding: "16px",
          }}
          editState={editState}
          active={selected === "and" ? 1 : 0}
          onClick={() => {
            setSelected("and");
            formikProps.setValues((prev) => ({
              ...prev,
              query_type: "and",
            }));
          }}
        >
          {/* LEFT CONTENT */}
          <Box sx={{ display: "flex", gap: "12px" }}>
            <LinkIcon
              sx={{ color: editState ? colors.publicisBlue : "#808080" }}
            />

            <Box>
              <Typography
                sx={{
                  color: editState ? colors.publicisBlue : "#808080",
                  fontWeight: 600,
                }}
              >
                AND Logic (Match All)
              </Typography>

              <Typography sx={{ color: "#333", fontSize: "14px" }}>
                Matches users who meet all selected audience filters.
              </Typography>
            </Box>
          </Box>

          {/* RIGHT SIDE TICK */}
          {selected === "and" && (
            <CheckCircle
              sx={{
                color: colors.publicisBlue,
                borderRadius: "50%",
                fontSize: 24,
                marginTop: "4px",
              }}
            />
          )}
        </Card>
      </Grid>
    </Fragment>
  );
}
